import React from "react";
import { Link } from "react-router-dom";
import { handleOpenVideoPage } from "@/app/libs/const/handleOpenVideoPage";

interface VideoLinkProviderProps {
  children: React.ReactNode;
  timestamp: number | 0;
  slugText: string;
  from: string;
  videoType: number;
  appId: number;
  videoId: number;
  onboardingVideoId?: number;
  userName?: string;
  organizationId?: string;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export const VideoLinkProvider: React.FC<VideoLinkProviderProps> = ({
  children,
  timestamp = 0,
  slugText,
  from = "Home Page screens",
  videoType = 1,
  appId,
  videoId,
  onboardingVideoId,
  userName = "",
  organizationId = "",
  className,
  onClick,
}) => {
  // Build the URL using the same logic as handleOpenVideoPage
  const buildUrl = () => {
    let newUrl = `/apps/${slugText}/?ts=${timestamp}&vt=${videoType}`;

    if (appId !== undefined) {
      newUrl += `&id=${appId}`;
    }

    if (videoId !== undefined) {
      newUrl += `&av=${videoId}`;
    }

    if (onboardingVideoId !== undefined) {
      newUrl += `&obv=${onboardingVideoId}`;
    }

    return newUrl;
  };

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Prevent default link behavior
    e.preventDefault();

    // Call custom onClick if provided
    if (onClick) {
      onClick(e);
    }

    // Call the original handleOpenVideoPage function
    handleOpenVideoPage(
      timestamp,
      slugText,
      from,
      videoType,
      appId,
      videoId,
      onboardingVideoId,
      userName,
      organizationId,
    );
  };

  return (
    <Link to={buildUrl()} onClick={handleClick} className={className}>
      {children}
    </Link>
  );
};
